import { render, staticRenderFns } from "./CargueFacturas.vue?vue&type=template&id=123568f2"
import script from "./CargueFacturas.vue?vue&type=script&lang=js"
export * from "./CargueFacturas.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports